<template>
    <div class="d-flex flex-column flex-sm-row justify-content-center align-items-center px-5 mt-3" style="background: #ecf7ff">
        <img
            alt="Ideasfundx logo"
            src="../../../../assets/img/m-1.png"
            class="w-25"
        />
        <div class="col-12 col-sm-9">
            <div class="col-12 py-0">
                <p class="text-sm-left m-0">Raising amount for this round (in US dollars)</p>
                <v-text-field
                    v-model="fund_raising"
                    class="text-bold text-right-input"
                    placeholder="99"
                    outlined
                    dense
                    disabled
                />
            </div>

            <div class="col-12 py-0">
                <p class="text-sm-left m-0">Investment stage of the company</p>
                <v-textarea
                    v-model="investmentStage.stage"
                    class="text-bold"
                    placeholder="99"
                    outlined
                    rows="2"
                    dense
                    disabled
                />
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            company_id: Number,
            investmentStage: Object,
            stages: Array,
            fund_raising: String
        },
    }
</script>